import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_studentenquiry,
  add_studentenquiry,
  update_studentenquiry,
  delete_studentenquiry,
  get_studentenquiry_list,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  studentenquiry: [],
  studentenquirylist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    session: "",
    name: "",
    // date_of_birth: "",
    // pan_no: "",
    // aadhar_no: "",
    // age: "",
    gender: "",
    // blood_group: "",
    // mother_tongue: "",
    // nationality: "",
    // religion: "",
    // caste: "",
    // category: "",
    school_class: "",
    mobile_no: "",
    email: "",
    house_no: "",
    street: "",
    area: "",
    P_O: "",
    distt: "",
    city: "",
    state: "",
    pin: "",
    father_name: "",
    father_academic_qualification: "",
    father_occupation: "",
    father_designation: "",
    father_office_phone_no: "",
    father_work_detail: "",
    father_annual_income: "",
    father_phone: "",
    counsellor: "",
    // mother_name: "",
    // mother_academic_qualification: "",
    // mother_occupation: "",
    // mother_designation: "",
    // mother_office_phone_no: "",
    // mother_work_detail: "",
    // mother_annual_income: "",
    // mother_phone: "",
    // guardian_name: "",
    // guardian_academic_qualification: "",
    // guardian_occupation: "",
    // guardian_designation: "",
    // guardian_relation: "",
    // guardian_phone: "",
    // previous_school_name_address: "",
    // previous_school_class: "",
    // previous_school_session: "",
    // previous_school_board: "",
    // previous_school_medium: "",
    // at_school: "",
    // distance_from_home: "",
   
  },
};
// Async Thunks for API Calls
export const fetchstudentenquirylist = createAsyncThunk(
  "studentenquiry/fetchstudentenquirylist",
  async ({ school_id, enquiry_no, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_studentenquiry_list(
        school_id,
        enquiry_no,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async Thunks for API Calls
export const fetchstudentenquiry = createAsyncThunk(
  "studentenquiry/fetchstudentenquiry",
  async (
    { page, page_size, school_id, enquiry_no,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_studentenquiry(
        page,
        page_size,
        school_id,
        enquiry_no,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createstudentenquiry = createAsyncThunk(
  "studentenquiry/createstudentenquiry",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_studentenquiry(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatestudentenquiry = createAsyncThunk(
  "studentenquiry/updatestudentenquiry",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_studentenquiry(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletestudentenquiry = createAsyncThunk(
  "studentenquiry/deletestudentenquiry",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_studentenquiry({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const studentenquirySlice = createSlice({
  name: "studentenquirys",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(reduxState) {
        reduxState.formData = {
          session: "",
          name: "",
          date_of_birth: "",
          pan_no: "",
          aadhar_no: "",
          age: "",
          gender: "",
          blood_group: "",
          mother_tongue: "",
          nationality: "",
          religion: "",
          caste: "",
          category: "",
          school_class: "",
          mobile_no: "",
          email: "",
          house_no: "",
          street: "",
          area: "",
          P_O: "",
          distt: "",
          city: "",
          state: "",
          pin: "",
          father_name: "",
          father_academic_qualification: "",
          father_occupation: "",
          father_designation: "",
          father_office_phone_no: "",
          father_work_detail: "",
          father_annual_income: "",
          father_phone: "",
          mother_name: "",
          mother_academic_qualification: "",
          mother_occupation: "",
          mother_designation: "",
          mother_office_phone_no: "",
          mother_work_detail: "",
          mother_annual_income: "",
          mother_phone: "",
          guardian_name: "",
          guardian_academic_qualification: "",
          guardian_occupation: "",
          guardian_designation: "",
          guardian_relation: "",
          guardian_phone: "",
          previous_school_name_address: "",
          previous_school_class: "",
          previous_school_session: "",
          previous_school_board: "",
          previous_school_medium: "",
          at_school: "",
          distance_from_home: "",
           counsellor: "",
      };
    },
    setstudentenquiry(state, action) {
      state.studentenquiry = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchstudentenquirylist.fulfilled, (state, action) => {
        state.studentenquirylist = action.payload.data;
      })
      .addCase(fetchstudentenquirylist.rejected, (state, action) => {
        state.studentenquirylist = [];

      })
      // Fetch hostel_category
      .addCase(fetchstudentenquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchstudentenquiry.fulfilled, (state, action) => {
        state.loading = false;
        state.studentenquiry = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchstudentenquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createstudentenquiry.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createstudentenquiry.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createstudentenquiry.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updatestudentenquiry.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatestudentenquiry.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatestudentenquiry.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
               state.IsEditing = false;
               const errorMessage = action?.payload?.data?.message || "Something went wrong!";
               toast.info(errorMessage); 
      })
      // Delete hostel_category
      .addCase(deletestudentenquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletestudentenquiry.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletestudentenquiry.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setstudentenquiry,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = studentenquirySlice.actions;
export default studentenquirySlice.reducer;
